import { render, staticRenderFns } from "./SliPolygonsMap.vue?vue&type=template&id=b62af2ce&scoped=true"
import script from "./SliPolygonsMap.vue?vue&type=script&lang=js"
export * from "./SliPolygonsMap.vue?vue&type=script&lang=js"
import style0 from "./SliPolygonsMap.vue?vue&type=style&index=0&id=b62af2ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62af2ce",
  null
  
)

export default component.exports